<template>
  <el-table-column
    prop="company.name"
    sortable="custom"
    label="Szállító"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      #{{ scope.row.supplier.id }} {{ scope.row.supplier.company.name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'company.name',
};
</script>
